export default [
    {
        className:"white-card",
        Package:"Basic",
        Price:"$199.9",
        priceClass:"basic-price",
        Capacity:"500 GB Storage",
        Users:"2 Users Allowed",
        SendAmount:"Send up to 5GB",
        moreClass:"learn"
    },
    {
        className:"card",
        Package:"Proffesional",
        Price:"$299.9",
        priceClass:"rofessional-price",
        Capacity:"1 TB Storage",
        Users:"5 Users Allowed",
        SendAmount:"Send up to 10GB",
        moreClass:"more"
    },
    {
        className:"white-card",
        Package:"Master",
        Price:"399.9",
        priceClass:"master-price",
        Capacity:"2 TB Storage",
        Users:"10 Users Allowed",
        SendAmount:"Send up to 20GB",
        moreClass:"learn"
    }
]